export default function PrePenIco() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.41641 5.93501L3.49101 11.3335C3.46795 11.4726 3.49066 11.6155 3.55671 11.7403L6.6166 8.68042C6.24093 8.16916 6.29404 7.46045 6.74238 7.01141C7.99068 5.84977 9.72255 7.5845 8.55954 8.82857C8.11223 9.27379 7.40806 9.32935 6.89612 8.95995L3.83624 12.0198C3.96134 12.0855 4.10497 12.1082 4.24441 12.0841L9.6415 11.1602C9.88682 11.1168 10.086 10.9379 10.1559 10.6989L10.9317 8.03325C10.9163 8.03185 7.55595 4.65747 7.54333 4.64486L4.87905 5.41933C4.63897 5.48888 4.45935 5.68877 4.41636 5.93515L4.41641 5.93501Z"
        fill="white"
      />
      <path
        d="M9.02149 7.8929C8.98569 7.35427 8.53853 6.93608 7.99877 6.93608C7.459 6.93608 7.01183 7.35427 6.97605 7.8929C7.01696 9.24518 8.97843 9.24289 9.02149 7.8929Z"
        fill="white"
      />
      <path
        d="M7.8612 4.40612L11.1685 7.71346C11.4002 7.94515 11.7756 7.94515 12.0072 7.71346L13.1549 6.56583C13.3866 6.33414 13.3866 5.95881 13.1549 5.72712L9.84753 2.41979C9.61584 2.1881 9.24051 2.1881 9.00882 2.41979L7.8612 3.56741C7.62951 3.7991 7.62951 4.17443 7.8612 4.40612Z"
        fill="white"
      />
      <path
        d="M4.20402 11.9856L4.20477 11.9856L6.97242 9.83299L9.74016 9.52546L10.0477 7.98783L7.58747 5.52761L6.35736 6.14267L5.74231 8.60288C5.02478 9.32041 3.59008 10.8784 3.58979 11.3705C3.58942 11.9856 3.58968 11.9856 4.20402 11.9856Z"
        fill="white"
      />
    </svg>
  );
}
